import React from 'react';
import { ComposedChart, Bar, XAxis, YAxis, CartesianGrid, Legend, ResponsiveContainer, LabelList, Line, Tooltip } from 'recharts';
import styles from "./barAndLineComboChart.module.css";

const BarAndLineChartAlternateExcessInventory = ({ data, Wk, baseUnitOfMeasure}) => {
    const transformedData = data?.map(item => {
        return {
            excessInventory: parseFloat(item[`Excess inv.(Wk ${Wk})`] || 0).toFixed(2),
            transitTime: item["Transit Time"] || 0,
            siteCluster: item["Site Cluster"] || ""
        };
    }).filter(item => item.excessInventory > 0);

    // Calculate max values for domains
    const maxExcess = Math.max(...transformedData.map(item => parseFloat(item.excessInventory)));
    const maxTransit = Math.max(...transformedData.map(item => item.transitTime));

    const CustomLegend = (props) => {
        const { payload } = props;
        return (
            <div style={{ display: 'flex', justifyContent: 'left', padding: '10px' }}>
                {payload.map((entry, index) => {
                    const { value, color } = entry;
                    return (
                        <span
                            key={`item-${index}`}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '4px',
                                padding: '0 10px',
                            }}
                        >
                            <span
                                style={{
                                    backgroundColor: color,
                                    width: '6px',
                                    height: '12px',
                                    display: 'inline-block',
                                    borderRadius: '2px',
                                }}
                            />
                            <span style={{ color: '#4D4D4F' }}>{value}</span>
                        </span>
                    );
                })}
            </div>
        );
    };

    const legendStyle = {
        fontSize: '10px',
        paddingTop: '15px',
        color: '#4D4D4F',
    };

    const CustomTooltip = ({ active, payload }) => {
        if (active && payload && payload.length) {
            return (
                <div className={styles.customTooltip}>
                    {payload.map((item, index) => {
                        return (
                            <p key={index} className={styles.tooltipItem}>
                                <span style={{ fontWeight: 500 }}>{item.name}</span> : {item.value}
                            </p>
                        );
                    })}
                </div>
            );
        }
        return null;
    };

    return (
        <>
            <ResponsiveContainer width="100%" height={220}>
                <ComposedChart data={transformedData}
                    margin={{
                        top: 10,
                        right: 20,
                        bottom: 5,
                        left: 0,
                    }} >
                    {/* <CartesianGrid strokeDasharray="3 3" vertical={false} horizontal={true} /> */}
                    <XAxis dataKey="siteCluster" tickLine={false} axisLine={true} className={styles.BarLabel} padding={{ left: 0, right: 0 }} />
                    <YAxis 
                        yAxisId="left" 
                        domain={[0, Math.round(maxExcess * 1.1)]} 
                        tickLine={false} 
                        axisLine={false} 
                        label={false}
                        tick={false} // This will hide all ticks
                        className={styles.BarLabel} 
                    />
                    
                    <YAxis 
                        yAxisId="right" 
                        orientation="right" 
                        domain={[0, Math.round(maxTransit * 1.1)]} 
                        tickLine={false} 
                        axisLine={false} 
                        label={false}
                        tick={false} // This will hide all ticks                  
                        className={styles.BarLabel} 
                    />
                    <Tooltip
                        content={<CustomTooltip />}
                        wrapperStyle={{
                            fontSize: '12px',
                            padding: '6px',
                        }}
                    />
                    <Legend verticalAlign="bottom" align="left" wrapperStyle={legendStyle} content={<CustomLegend />} />

                    <Bar
                        yAxisId="left"
                        radius={[4, 4, 0, 0]}
                        dataKey="excessInventory"
                        name={`Excess inventory (${baseUnitOfMeasure})`} // Dynamically using baseUnitOfMeasure from props
                        fill="#005EEF"
                        barSize={25}
                    >
                        <LabelList
                            dataKey="excessInventory"
                            position="top"
                            style={{ fill: '#2B2B2B', fontSize: 10, fontWeight: "500" }}
                        />
                    </Bar>

                    <Line 
                        yAxisId="right"
                        type="monotone" 
                        dataKey="transitTime" 
                        name="Transit time (days)" 
                        stroke="#FFC000" 
                        fill="#FFC000" 
                        strokeWidth={1} 
                    />
                </ComposedChart>
            </ResponsiveContainer>
        </>
    );
};

export default BarAndLineChartAlternateExcessInventory;